import { gql } from 'graphql-tag'

export default gql`
  fragment PageUpliftDetailFragment on PageUpliftDetail {
    sys {
      id
    }
    title
    slug
    productName
    productIcon
    hero {
      description {
        json
      }
    }
  }
`
